import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { AuthState } from '../auth/auth.state';
import { SetSession } from '../bridge/bridge.model';
import { BridgeService } from '../bridge/bridge.service';
import { LoggerService } from '../common/logger.service';
import { COOKIE_DEV } from '../constants';
import { StorageService } from '../storage/storage.service';
import { UserState } from '../user/user.state';
import { decodeCookie, decodeResponseBridge, merge, pick, unserializeFromStringToObject } from '../util.class';
import { GetFromBridge, GetFromCookie, GetFromMock, GetKeyMapAWS, SetLinkAccountFromApp, SetMsisdnFromApp } from './session.action';
import { SessionStateModel } from './session.model';
import { ApiService } from '../api';

@State<SessionStateModel>({
  name: 'session',
  defaults: {
    device: null,
    auth: null,
    items: null,
    customer: null,
    currentItem: null,
    accountInfo: null,
    userInfo: null,
    keyMapAWS: null,
    keyMapActions: null
  },
  children: [AuthState, UserState],
})
@Injectable()
export class SessionState {
  constructor(private bridge: BridgeService, private storage: StorageService, private api: ApiService, private logger: LoggerService) { }

  @Action(SetMsisdnFromApp)
  setMsisdnFromApp({ setState, getState }: StateContext<SessionStateModel>, { params }: SetMsisdnFromApp) {
    const { msisdn } = params;
    const { items } = getState();
    return setState(
			merge([
			  getState(),
			  { currentItem: { msisdn, isMyMsisdn: !!items.find((d) => d.msisdn === msisdn) } },
			]) as SessionStateModel
    );
  }

  @Action(SetLinkAccountFromApp)
  setLinkAccountFromApp({ setState, getState }: StateContext<SessionStateModel>, { params }: SetLinkAccountFromApp) {
	  const { fixedLineInfo } = params;

	  return setState(
			merge([
			  getState(),
			  { currentItem: { fixedLineInfo: fixedLineInfo } },
			]) as SessionStateModel
	  );
  }

  @Action(GetKeyMapAWS)
  async getKeyMapAWS({ setState, getState }: StateContext<SessionStateModel>, { path }: any) {
	  const keyMapAWS = await this.api.session.getConfigurationKeyAWS(path).toPromise();

	  return setState(
			merge([
			  getState(),
			  {
			    keyMapAWS: keyMapAWS.endpoints,
			    keyMapActions: keyMapAWS.actions
			  },
			]) as SessionStateModel
	  );
  }

  @Action(GetFromBridge)
  async getFromBridge({ setState }: StateContext<SessionStateModel>) {
	  this.bridge.events.subscribe((event) => {
	    if (event instanceof SetSession) {
        const { params } = event;
        console.log('SESSION RAW', event);
	      setState(decodeResponseBridge(params) as SessionStateModel);
	    }
	  });

	  await this.bridge.ready();
  }

  @Action(GetFromCookie)
  getFromCookie({ setState }: StateContext<SessionStateModel>) {
	  const devCookie = this.storage.cookie.pull(COOKIE_DEV);
	  if (devCookie) {
	    const session = decodeCookie(devCookie as string);
	    console.log('=>>>>>>>>>>>>DEV COOKIE DECODED', session);
	    setState(this.setSession(session));
	  } else {
	    // using void object
	    try {
	      setState(this.setSession({
	        device: null,
	        customer: null,
	        currentItem: null,
	        accountInfo: null,
	        userInfo: null,
	      }));
	    } catch (err) {
	      this.logger.error(err);
	    }
	  }
  }

  @Action(GetFromMock)
  getFromMock({ setState }: StateContext<SessionStateModel>) {
	  setState({
	    isOverlay: true,
	    device: {
	      installationId: 'a71e8f5e9c894319827b49ed0d66048a',
	      deviceVendor: 'unknown',
	      deviceOs: 'unknown',
	      deviceModel: 'unknown',
	      deviceIsTablet: false,
	      appId: 'unknown',
	      appPlatform: 'unknown',
	      appVersion: '6.18.0',
	      networkInfo: 'unknown',
	    },
	    auth: {
	      sessionId: '5fbe3e2b7802aa0001a93672',
	      token:
					'eyJhbGciOiJSUzI1NiJ9.eyJzZXNzaW9uX2lkIjoiNWZiZTNlMmI3ODAyYWEwMDAxYTkzNjcyIiwic3ViIjoidm9kYWZvbmUtZHhsIiwiaXNzIjoianMtbG9naW4iLCJhdWQiOiJhdWRpZW5jZV92YWx1ZSIsImV4cCI6MTYwNjMwNjg3NX0.BgEqI7Pab4lIlanKZt1HprptfAp1ibKKQ9fN6a7nWGV8kEE8BAFA_0cbQFQ3bF9bFl1ruASvVXXGjFVEjguX6g-XiaH4Dr9iqMGbjKabOwmvEiOw_-ulQiA101nbXuK6okaZMRl_UymwqFd_YAe-bydadd9Lf29-a9CjRAigTehbVKK3yof63ha7bp_C7oalx3OO1dZ8fJngRUBIrCZVRZnoCaad-7BXvuokiPzMtVG8P7jOtETEbLBKPRq1J3L4aSl8FCEhvxo68Bmexji8MgeEd92Zc-44uFDtsaZaLR8UO2bEQ-LNjwYsF1yrAdFQj7WdqHjLUy14Q_URqbvXGw',
	      tokenExchangeMap: {
	        'token-1': 'value-1',
	        'token-2': 'value-2',
	        'token-n': 'value-N'
	      }
	    },
	    customer: {
	      username: '3491856746.ref@gmail.com',
	      email: 'ricci.cex@gmail.com',
	      custCode: '7.1466057',
	      userType: 'chooser',
	      walletId: '',
	      code: 'CORPORATE',
	      isDunning: 'true',
	      isHotline: 'false',
	      customerCodeCompany: '7.1466057',
	      type: 'Corporate',
	      isEnriched: false,
	      profile: 'BUSINESS_MASTER_REFERENT',
	      name: 'Camillo',
	      surname: 'Ricci',
	      segment: 'SME',
	      isTm9: true
	    },
	    currentItem: {
	      id: '210037574',
	      msisdn: '3427414557',
	      isMyMsisdn: true,
	      pbo: 'e3d14df62f1dddc52104c78582a2adf4',
	      customerCodePerson: '7.1466057.00.00.1062',
	      dual: false,
	      userPlus: true,
	      subscriptionType: 'Paym',
	      fixedLineInfo: { linkAccountId: '452415', cliNumber: '0234524242' }
	    },
	    items: [{ msisdn: '3405051294' }],
	    accountInfo: {
	      tealiumAccountInfo: {
	        userName: '',
	        email: '',
	        persistentBO: '',
	        profileID: '',
	        segment: 'CB',
	        market: 'Business',
	        businessType: '',
	        businessSubType: '',
	        gender: '',
	        age: 0,
	        status: 'Logged in',
	        subscriptionType: '',
	        postalCode: 0,
	        accountManagerID: '',
	        tenure: 1,
	        dateOfBirth: '',
	        paymentType: ''
	      }
	    },
	    userInfo: {
	      tealiumUserInfo: {
	        userName: '',
	        email: '',
	        persistentBO: '',
	        profileID: '',
	        segment: 'CB',
	        market: 'Business',
	        businessType: '',
	        businessSubType: '',
	        gender: '',
	        age: 0,
	        status: 'Logged in',
	        subscriptionType: '',
	        postalCode: 0,
	        accountManagerID: '',
	        tenure: 1,
	        dateOfBirth: '',
	        paymentType: ''
	      }
	    },
	  });
  }

  private setSession(session) {
	  const device = pick(session, [
	    'installationId',
	    'deviceVendor',
	    'deviceModel',
	    'deviceIsTablet',
	    'appId',
	    'appPlatform',
	    'appVersion',
	  ]);

	  const auth = pick(session, ['sessionId', 'token']);
	  if (session?.tokenExchangeMap) {
	    auth.tokenExchangeMap = unserializeFromStringToObject(session.tokenExchangeMap);
	  }

	  const customer = {
	    ...pick(session, [
	      'username',
	      'email',
	      'custCode',
	      'userType',
	      'walletId',
	      'segment',
	      'profile',
	      'name',
	      'surname',
	      'isTm9',
	      'isDunning',
	      'isHotline'
	    ]),
	    isEnriched: session.isEnriched === 'true'
	  };

	  const currentItem = {
	    ...pick(session, ['id', 'msisdn', 'pbo', 'customerCodePerson', 'code', 'customerCodeCompany']),
	    type: session.type?.toUpperCase(),
	    isMyMsisdn: session.isMyMsisdn === 'true',
	    dual: session.dual === 'true',
	    userPlus: session.userPlus === 'true',
	  };

	  const accountInfo = { ...pick(session, ['tealiumAccountInfo']) };
	  const userInfo = { ...pick(session, ['tealiumUserInfo']) };

	  return {
	    device: { ...device, deviceIsTablet: device.deviceIsTablet === 'true' },
	    auth,
	    customer,
	    currentItem,
	    items: session?.items?.split(',').map((d) => ({ msisdn: d })),
	    accountInfo,
	    userInfo,
	  };
  }
}
